export function getColorByPercentage(percentage: number) {
  // Paleta 10 barev od červené po zelenou v Tailwind CSS třídách
  const colors = [
    "bg-red-600", // 0-10% - Červená
    "bg-red-500", // 10-20% - Světlejší červená
    "bg-orange-500", // 20-30% - Tmavě oranžová
    "bg-orange-400", // 30-40% - Oranžová
    "bg-amber-400", // 40-50% - Žlutě oranžová
    "bg-yellow-400", // 50-60% - Žlutá
    "bg-lime-400", // 60-70% - Žlutě zelená
    "bg-lime-500", // 70-80% - Světle zelená
    "bg-green-500", // 80-90% - Zelená
    "bg-green-600", // 90-100% - Tmavě zelená
  ];

  // Výběr barvy podle procenta
  const colorIndex = Math.floor(percentage / 10);

  // Pro hodnotu přesně 10 použijeme poslední barvu
  return colors[Math.min(colorIndex, colors.length - 1)];
}
